import styled from "styled-components";
const Div = styled.div`
margin: auto;
margin-top: 2rem;
display: flex;
justify-content: center;
align-items: center;
`;
export default Div;